'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});
exports['default'] = FilesGallery;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _gsap = require('gsap');

var _pubsub = require('pubsub');

var _pubsub2 = _interopRequireDefault(_pubsub);

var _masonryLayout = require('masonry-layout');

var _masonryLayout2 = _interopRequireDefault(_masonryLayout);

function FilesGallery() {

	_pubsub2['default'].on('loader:hide', function () {
		var elems = document.querySelectorAll('.files_list');
		if (!elems) return;

		for (var index = 0; index < elems.length; index++) {
			var elem = elems[index];
			var msnry = new _masonryLayout2['default'](elem, {
				// options
				initLayout: true,
				itemSelector: '.files_list_item',
				percentPosition: true,
				horizontalOrder: true,
				gutter: 10,
				stagger: 30
			});
		}
	});
}

module.exports = exports['default'];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9Vc2Vycy9iYWJlL1dvcmsvdjIuZG91YmxlZy51bHRyYW5vaXIuY29tL2Fzc2V0cy9zY3JpcHRzL3BhcnRpYWxzL2ZpbGVzLWdhbGxlcnkuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7cUJBS3dCLFlBQVk7Ozs7b0JBTFAsTUFBTTs7c0JBQ2hCLFFBQVE7Ozs7NkJBQ1AsZ0JBQWdCOzs7O0FBR3JCLFNBQVMsWUFBWSxHQUFHOztBQUV0QyxxQkFBTyxFQUFFLENBQUMsYUFBYSxFQUFFLFlBQVU7QUFDbEMsTUFBSSxLQUFLLEdBQUcsUUFBUSxDQUFDLGdCQUFnQixDQUFDLGFBQWEsQ0FBQyxDQUFDO0FBQ3JELE1BQUcsQ0FBQyxLQUFLLEVBQUUsT0FBTzs7QUFFbEIsT0FBSyxJQUFJLEtBQUssR0FBRyxDQUFDLEVBQUUsS0FBSyxHQUFHLEtBQUssQ0FBQyxNQUFNLEVBQUUsS0FBSyxFQUFFLEVBQUU7QUFDbEQsT0FBTSxJQUFJLEdBQUcsS0FBSyxDQUFDLEtBQUssQ0FBQyxDQUFDO0FBQzFCLE9BQUksS0FBSyxHQUFHLCtCQUFhLElBQUksRUFBRTs7QUFFOUIsY0FBVSxFQUFFLElBQUk7QUFDaEIsZ0JBQVksRUFBRSxrQkFBa0I7QUFDaEMsbUJBQWUsRUFBRSxJQUFJO0FBQ3JCLG1CQUFlLEVBQUUsSUFBSTtBQUNyQixVQUFNLEVBQUUsRUFBRTtBQUNWLFdBQU8sRUFBRSxFQUFFO0lBQ1gsQ0FBQyxDQUFDO0dBR0g7RUFDRCxDQUFDLENBQUM7Q0FDSCIsImZpbGUiOiIvVXNlcnMvYmFiZS9Xb3JrL3YyLmRvdWJsZWcudWx0cmFub2lyLmNvbS9hc3NldHMvc2NyaXB0cy9wYXJ0aWFscy9maWxlcy1nYWxsZXJ5LmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgVGltZWxpbmVMaXRlIH0gZnJvbSAnZ3NhcCc7XG5pbXBvcnQgcHVic3ViIGZyb20gJ3B1YnN1Yic7XG5pbXBvcnQgTWFzb25yeSBmcm9tICdtYXNvbnJ5LWxheW91dCc7XG5cblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gRmlsZXNHYWxsZXJ5KCkge1xuXG5cdHB1YnN1Yi5vbignbG9hZGVyOmhpZGUnLCBmdW5jdGlvbigpe1xuXHRcdHZhciBlbGVtcyA9IGRvY3VtZW50LnF1ZXJ5U2VsZWN0b3JBbGwoJy5maWxlc19saXN0Jyk7XG5cdFx0aWYoIWVsZW1zKSByZXR1cm47XG5cblx0XHRmb3IgKGxldCBpbmRleCA9IDA7IGluZGV4IDwgZWxlbXMubGVuZ3RoOyBpbmRleCsrKSB7XG5cdFx0XHRjb25zdCBlbGVtID0gZWxlbXNbaW5kZXhdO1xuXHRcdFx0dmFyIG1zbnJ5ID0gbmV3IE1hc29ucnkoIGVsZW0sIHtcblx0XHRcdFx0Ly8gb3B0aW9uc1xuXHRcdFx0XHRpbml0TGF5b3V0OiB0cnVlLFxuXHRcdFx0XHRpdGVtU2VsZWN0b3I6ICcuZmlsZXNfbGlzdF9pdGVtJyxcblx0XHRcdFx0cGVyY2VudFBvc2l0aW9uOiB0cnVlLCBcblx0XHRcdFx0aG9yaXpvbnRhbE9yZGVyOiB0cnVlLFxuXHRcdFx0XHRndXR0ZXI6IDEwLFxuXHRcdFx0XHRzdGFnZ2VyOiAzMFxuXHRcdFx0fSk7XG5cblxuXHRcdH1cblx0fSk7XG59XG4iXX0=